import React from "react";
import { IconProps } from "../icon";

export const Hourglass_01Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 12L7.727 8.44c-.635-.53-.952-.794-1.18-1.119a3 3 0 01-.444-.947C6 5.991 6 5.578 6 4.752V2m6 10l4.273-3.56c.635-.53.952-.794 1.18-1.119a3 3 0 00.444-.947C18 5.991 18 5.578 18 4.752V2m-6 10l-4.273 3.56c-.635.53-.952.794-1.18 1.119a3 3 0 00-.444.947C6 18.009 6 18.422 6 19.248V22m6-10l4.273 3.56c.635.53.952.794 1.18 1.119a3 3 0 01.444.947c.103.383.103.796.103 1.622V22M4 2h16M4 22h16"
    />
  </svg>
);
